import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@macs-frontend/env';
import { buildQueryString } from '@macs-frontend/web-macs/core/utils/uri-utils';
import { UploadedFile } from '@macs-frontend/web-macs/shared/models/uploaded-file';
import { from } from 'rxjs';

@Injectable()
export abstract class ApiService {
  protected readonly API_PATH = environment.api_url;

  constructor(protected http: HttpClient) {}

  uploadFile(file: File, type = 'image') {
    const form = new FormData();
    form.append('file', file);
    form.append('type', type);
    return this.http.post<UploadedFile | string>(`${this.API_PATH}/files`, form);
  }

  protected stringify(queryParams: any, arrayToCommaSeparatedString = true) {
    return buildQueryString(queryParams, arrayToCommaSeparatedString);
  }

  /**
   * Fire-and-forget POST that survives page unload (used to release the
   * invoice edit lock). It bypasses HttpClient, so no interceptor attaches a
   * token — the caller passes one.
   *
   * `localStorage.token` used to be read here directly. Under Keycloak that
   * key is empty, so the header went out as the literal "Bearer undefined"
   * and the backend rejected it ("Wrong number of segments"), leaving the
   * invoice locked for everyone else. Send no header rather than a broken
   * one, and let callers supply the real token.
   */
  keepalivePost(url: string, data: object, token?: string) {
    const bearer = token || localStorage.getItem('token');
    return from(
      fetch(url, {
        method: 'POST',
        keepalive: true,
        headers: {
          'Content-Type': 'application/json',
          ...(bearer ? { Authorization: `Bearer ${bearer}` } : {}),
        },
        body: JSON.stringify(data),
      }),
    );
  }
}
